import { Button, DataHeader, DataSource, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommForm extends Layout {
    buttonCopy: Button;
    dataheaderMobileCommwForm: DataHeader;
    panelFormDisplay: Panel;
    buttonExApp: Button;
    sourceMobileCommForm: DataSource;
    sourceMobileCommFormFieldOpt: DataSource;
    switchActive: Switch;
    switchReceiptConfirmation: Switch;
    tabEditFormDisplay: Tab;
    tabFormDisplay: Tab;
    tabFormDisplayTable: Tab;
    tabFormFieldName: Tab;
    tabGeneral: Tab;
    tableFormFieldOpt: Table;
    tabsetForm: Tabset;
    tabsetMobileCommControl: Tabset;
    textboxCreationDate: Textbox;
    textboxDeliveryPriority: Textbox;
    textboxFieldName: Textbox;
    textboxFormType: Textbox;
    textboxId: Textbox;
    textboxStatus: Textbox;
    textboxTitle: Textbox;
    textboxVendor: Textbox;
    textboxVersion: Textbox;
}
